// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import "@babel/polyfill";
import vuetify from '@/plugins/vuetify';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/zh-TW'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/login/fb_config.js'
import App from './App'
import router from './router'
import ImgLoader from '@/components/ImgLoader'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required, email } from 'vee-validate/dist/rules'
import MenuIcon from 'vue-material-design-icons/Menu.vue';
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import PurgeIconsVue from 'purge-icons-vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueYoutube from 'vue-youtube'
import VueYouTubeEmbed from 'vue-youtube-embed'



extend('required', {
  ...required,
  message: '請填寫此欄位！'
})
extend('phone', {
  validate(value) {
    if(value.includes('-')) return true
    return  !isNaN(+value)
  },
  message: '電話格式不正確！'
})
extend('email', {
  ...email,
  message: 'email 格式不正確！'
})
extend('positive', {
  validate (value) {
    if (isNaN(+value) || value < 0) return false
    return true
  },
  message: '數值不可是負數'
})

extend('number', {
  validate (value) {
    return  !(isNaN(+value))
  },
  message: '只能填入數值'
})
extend('maxNum', {
  validate (value, arg) {
    return value <= arg.max
  },
  params: ['max'],
  message: '數值超過限制！',
  computesRequired: true
})
extend('max', {
  validate (value, arg) {
    return value.length <= arg.length
  },
  params: ['length'],
  message: '字數超過限制！',
  computesRequired: true
})

Vue.config.productionTip = false
Vue.use(ElementUI, { locale });
Vue.use(BootstrapVue);
Vue.use(IconsPlugin)
Vue.use(PurgeIconsVue);
Vue.use(VueYoutube);
Vue.use(VueYouTubeEmbed);
Vue.component('ImgLoader', ImgLoader)
Vue.component('VeeForm', ValidationObserver)
Vue.component('Vee', ValidationProvider)
Vue.component('menu-icon', MenuIcon);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  vuetify,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js